const ROUTES = [];

const router = {

	init()
	{
		window.addEventListener('hashchange', this.route);
		if (location.hash)
			this.route();
	},

	set(hash, callback)
	{
		let index = ROUTES.findIndex(route => route.hash == hash);
		ROUTES[index < 0 ? ROUTES.length : index] = { 'hash': hash, 'callback': callback };
	},

	route(ev)	// Can be event triggered or manually invoked
	{
		let hash = ev?.newURL?.slice(ev.newURL.indexOf('#')) || ev || location.hash;
		ROUTES.filter(entry => entry.hash == hash).forEach(entry => entry.callback());
	}

};

export default router;

